<div>
    <h4 [innerHTML]="'booking.bookingParticipants.addGroupAprticipantsTitle' | translate"></h4>
    <span class="number-of-Checked"
        ><strong>{{ currentNumberOfChecked }}</strong
        ><span [innerHTML]="'booking.bookingParticipants.off' | translate"></span><strong *ngIf="employees">{{ employees.length }}</strong
        ><span [innerHTML]="'booking.bookingParticipants.ofAllEmployees' | translate"></span
    ></span>
    <div class="employee-group">
        <div *ngFor="let employee of employees; let i = index" class="employee">
            <label class="checkboxlabel">
                <input
                    type="checkbox"
                    id="checkbox{{ i }}"
                    [checked]="checkedEmployeesId.indexOf(employee.id) > -1"
                    (change)="check($event, i)"
                />
                <label for="checkbox{{ i }}" class="subscribe-me">
                    <span class="main"
                        >{{ employee.salutation.name }} {{ employee.title }} {{ employee.firstName }} {{ employee.lastName }}</span
                    >
                    <span class="inner">{{ employee.department }}</span>
                </label>
            </label>
        </div>
    </div>
    <div class="button-wrapper">
        <a da-link class="button secondary" (click)="cancle()" [innerHTML]="'booking.bookingParticipants.back' | translate"></a>
        <a
            da-link
            class="button primary"
            (click)="addParticipants()"
            [innerHTML]="'booking.bookingParticipants.addParticipants' | translate"
        ></a>
    </div>
</div>
